var _defs, _g, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "x_mark",
    "data-name": "x mark",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30.147,
    height: 30.147,
    viewBox: "0 0 30.147 30.147",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2738",
    "data-name": "Rectangle 2738",
    width: 30.147,
    height: 30.147,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3960",
    "data-name": "Group 3960"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3960-2",
    "data-name": "Group 3960",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7299",
    "data-name": "Path 7299",
    d: "M30.147,15.074A15.074,15.074,0,1,1,15.074,0,15.073,15.073,0,0,1,30.147,15.074",
    fill: "#bcbcbc"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7116",
    "data-name": "Path 7116",
    d: "M519.2,829.9l-2.64-2.64-4.983,4.983-4.984-4.983-2.64,2.64,4.984,4.983-4.984,4.984,2.64,2.64,4.984-4.984,4.983,4.984,2.64-2.64-4.983-4.984Z",
    transform: "translate(-496.748 -820.055)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXMark);
export default __webpack_public_path__ + "static/media/xMark.d64b64cf9aa39b1096d2ac2619b90f5a.svg";
export { ForwardRef as ReactComponent };